import type { AccountModel } from '@trading/core/src/models/account.model'
import type { BalanceModel } from '@trading/core/src/models/balance.model'
import type { AccountRepository } from '@trading/core/src/repositories/account/account.repository'
import axios from '../axios'

type ApiEnvelope<T> = {
  data?: T
}

function unwrapApiData<T>(payload: unknown): T {
  if (payload && typeof payload === 'object' && 'data' in payload) {
    return (payload as ApiEnvelope<T>).data as T
  }

  return payload as T
}

export class AccountApiAxios implements AccountRepository {
  async getAccounts(): Promise<AccountModel[]> {
    return await axios
      .get<{ data: AccountModel[] }>('account/accounts')
      .then((resp) => resp.data.data)
      .catch((e) => {
        throw new Error(e)
      })
  }

  async getBalances(): Promise<BalanceModel[]> {
    const response = await axios.get('account/balances')
    const payload = unwrapApiData<BalanceModel[]>(response.data)

    return Array.isArray(payload) ? payload : []
  }
}
